import { useEffect, useRef, useState } from "react";
import { createProperties } from "../lib/api";
import ToastMessage from "./Common/ToastMessage";
import { useIsWriteRestrictedUser } from "../hooks/useIsWriteRestrictedUser";
import Label from "./Common/Label";

export default function PropertyCard({ setShowPropertyModal, onPropertyCreated }) {
    const isActionsDisabled = useIsWriteRestrictedUser();
    const modalRef = useRef(null);
    const [formdata, setFormData] = useState({ name: '' })
    const handlePropertyClose = () => {
        setShowPropertyModal(false);
    }
    const [errors, setErrors] = useState({});

    const [toast, setToast] = useState({
        show: false,
        message: '',
        type: 'success',
    });
    const showToast = (message, type = 'success') => {
        setToast({ show: true, message, type });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowPropertyModal(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setShowPropertyModal]);

    const handleChange = (e) => {
        setFormData({ name: e.target.value });
    }

    const validate = () => {
        const newErrors = {};
        if (!formdata.name || !formdata.name.trim()) {
            newErrors.name = 'Enter Property Name';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isActionsDisabled) return;

        if (!validate()) return;
        const trimmedData = { ...formdata, name: formdata.name.trim() };
        try {
            const res = await createProperties(trimmedData);
            if (res.status === 200) {
                onPropertyCreated(res?.data?.data);
                setShowPropertyModal(false);
            } else {
                console.log(res.message);
            }
        } catch (err) {
            if (err.status === 409) {
                showToast("Property name already taken", 'failed');
            } else {
                showToast("Delete Failed Due to network error", 'failed');
            }
        }
    }

    return (
        <>
            <div className="overlayHolder bg-black/30 dark:bg-black/60 fixed inset-0 flex justify-center z-[999]">
                <div
                    ref={modalRef}
                    className="modalHlder bg-[#F8F8F8] dark:bg-darkThemeModalBg dark:shadow-darkThemeModalShadow rounded-2xl border border-black/10 max-[430px]:w-full  w-[480px] max-h-[75%]  my-auto p-10 lg:px-8 lg:py-11 overflow-auto mx-5"
                >
                    <div className="flex gap-10 lg:gap-14">
                        <div className="modalContent basis-full lg:basis-[344px]">
                            <div className="flex flex-col gap-1">
                                <h2 className="modalTitle text-[#031641] dark:text-white text-xl leading-6 lg:text-2xl lg:leading-7 font-semibold tracking-[0.036px]">Create Property</h2>
                                <p className="text-[#000000DE] dark:text-white text-sm leading-5 tracking-[0.021px] font-normal w-full lg:w-11/12">Organize your Gradient units by location.</p>
                            </div>
                            <div className="modalFormHolder mt-6">
                                <form className="space-y-5 lg:space-y-7">
                                    <div className="properySection gap-1 flex flex-col">
                                        <div className="flex flex-col gap-1">
                                            <Label htmlFor="propertyName" className="propertyName text-[#00000099] dark:text-white font-normal text-base leading-5 tracking-[-0.24px]">Property Name</Label>
                                            <input
                                                id="propertyName"
                                                type="text"
                                                placeholder="Enter Property Name"
                                                name="name"
                                                className="w-full text-lg leading-6 py-2.5 px-3 rounded-md border border-[#CADBD5] text-dark-grey h-11 bg-white dark:darkThemeGradiantBg placeholder:text-dark-grey/40 dark:placeholder:text-white/40 dark:text-white font-medium tracking-[-0.408px] outline-none max-w-[300px]"
                                                value={formdata.name}
                                                onChange={handleChange}
                                            />
                                            {errors.name && (
                                                <p className='text-critical text-xs leading-4'>
                                                    {errors.name}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="mt-10 actionsHolder">
                                <div className="flex items-center  gap-4 lg:gap-6">
                                    
                                    <button
                                        className={`flex justify-center items-center basis-36 md:basis-1/2 grow-0 md:grow shrink bg-theme px-5 py-3 text-white text-base font-semibold leading-5 tracking-[-0.32px] rounded-md h-10 hover:bg-theme/80 transition-all duration-300 ease-in-out ${
                                            isActionsDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                                        }`}
                                        onClick={handleSubmit}
                                        disabled={isActionsDisabled}
                                    >
                                        Save
                                    </button>
                                    <button className="flex justify-center items-center basis-36 md:basis-1/2 grow-0 md:grow  shrink border border-theme px-5 py-3 text-theme text-base font-semibold leading-5 tracking-[-0.32px] rounded-md cursor-pointer h-10 hover:bg-theme hover:text-white transition-all duration-300 ease-in-out" onClick={handlePropertyClose}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastMessage
                message={toast.message}
                type={toast.type}
                show={toast.show}
                onClose={() => setToast(prev => ({ ...prev, show: false }))}
            />
        </>
    );
}
